export const MARQUEE_AREAS = [
  '東京駅周辺',
  '大阪駅周辺',
  '新宿駅周辺',
  '渋谷駅周辺',
  '京都駅周辺',
  '博多駅周辺',
  '札幌駅周辺',
  '仙台駅周辺',
  '広島駅周辺',
  '那覇空港周辺',
  '横浜駅周辺',
  '名古屋駅周辺',
  '羽田空港周辺',
  '成田空港周辺',
  '新千歳空港周辺',
]
